'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = Separator;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _divider = require('../divider');

var _divider2 = _interopRequireDefault(_divider);

function Separator(_ref) {
  var _ref$className = _ref.className;
  var className = _ref$className === undefined ? '' : _ref$className;
  var _ref$style = _ref.style;
  var style = _ref$style === undefined ? {} : _ref$style;

  return _react2['default'].createElement(_divider2['default'], {
    className: className,
    style: Object.assign({
      height: '8px',
      margin: '0 0 8px 0'
    }, style)
  });
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lib/components/menu/separator.js
// module id = 333
// module chunks = 0